import { useQuery } from "@tanstack/react-query";

import { partFeaturesQuery } from "../infra/partFeatures.query";

type Options = {
  enabled?: boolean;
};

export const usePartFeatures = (id: string | undefined, options?: Options) => {
  const { data, ...rest } = useQuery({
    ...partFeaturesQuery(id),
    enabled: !!id && options?.enabled,
  });

  return {
    features: data?.features ?? [],
    hasUserOverridden: data?.hasUserOverridden ?? false,
    ...rest,
  };
};
